import { Status } from '@vendasta/sales-orders';
import { IsOrderStatus } from './guard';

// Returns all non-string Order statuses
export function GetOrderStatuses(): Status[] {
  return Object.values(Status).filter(IsOrderStatus);
}
